// extracted by mini-css-extract-plugin
export var filterIncDec = "_cl-0";
export var leftBorder = "_cl-1";
export var rightBorder = "_cl-2";
export var stringInput = "_cl-3";